import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Building2, Users, FileSearch, Briefcase, FileText, CalendarCheck, Receipt, TrendingUp, BarChart3 } from "lucide-react";
import { GoogleConnect } from "@/components/GoogleConnect";

export default function AdminDashboard() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then(r => setData(r.data)).catch(() => {}); }, []);
  if (!data) return <div className="text-slate-500">Caricamento...</div>;
  const stats = [
    { label: "Aziende registrate", value: data.companies, icon: Building2, link: "/admin/companies" },
    { label: "Manager", value: `${data.managers_verified}/${data.managers}`, icon: Users, link: "/admin/managers" },
    { label: "Candidature pending", value: data.applications_pending, icon: FileSearch, link: "/admin/applications" },
    { label: "Richieste totali", value: data.requests, icon: FileText, link: "/admin/requests" },
    { label: "Shortlist pubblicate", value: data.shortlists_published, icon: Users, link: "/admin/matching" },
    { label: "Progetti attivi", value: data.projects_active, icon: Briefcase, link: "/admin/projects" },
    { label: "Call programmate", value: data.meetings_scheduled, icon: CalendarCheck, link: "/admin/meetings" },
    { label: "Lead da contatto", value: data.contact_requests, icon: TrendingUp, link: "/admin/requests" },
  ];
  return (
    <div>
      <h1 className="font-display text-2xl sm:text-3xl font-bold text-slate-900">Admin Dashboard</h1>
      <p className="mt-1 text-slate-600 mb-6">Panoramica operativa CXOORA.</p>

      <div className="mb-6">
        <GoogleConnect returnTo="/admin" />
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {stats.map((s, i) => {
          const Icon = s.icon;
          return (
            <Link to={s.link} key={i}>
              <div className="cxo-card p-5">
                <div className="flex items-center gap-2 text-slate-500"><Icon size={14} /><span className="text-xs uppercase tracking-wider font-semibold">{s.label}</span></div>
                <p className="mt-2 text-3xl font-display font-bold cxo-tabular text-slate-900">{s.value}</p>
              </div>
            </Link>
          );
        })}
      </div>

      <div className="mt-6 grid grid-cols-1 lg:grid-cols-3 gap-4">
        <div className="lg:col-span-2 cxo-card p-6">
          <h2 className="font-display text-lg font-semibold text-slate-900">Pipeline CRM</h2>
          <div className="mt-4 flex flex-wrap gap-2">
            {Object.entries(data.pipeline || {}).map(([stage, count]) => (
              <Badge key={stage} variant="outline" className="bg-white border-slate-200 text-slate-700 font-medium">
                {stage.replace(/_/g, " ")}: <span className="ml-1 font-bold cxo-tabular">{count}</span>
              </Badge>
            ))}
          </div>
          <Link to="/admin/requests" className="mt-4 inline-flex items-center text-sm font-semibold text-[#2D6BFF]">Apri pipeline completa →</Link>
        </div>
        <div className="cxo-card p-6">
          <h2 className="font-display text-lg font-semibold text-slate-900">Notifiche recenti</h2>
          <div className="mt-3 space-y-2">
            {(data.recent_notifications || []).slice(0, 5).map(n => (
              <div key={n.id} className="p-3 rounded-lg bg-slate-50 text-sm">
                <p className="font-semibold text-slate-900">{n.title}</p>
                <p className="text-xs text-slate-600">{n.body}</p>
              </div>
            ))}
            {!data.recent_notifications?.length && <p className="text-sm text-slate-500">Nessuna notifica</p>}
          </div>
        </div>
      </div>
    </div>
  );
}
